"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function HeaderProxyNewModal(t0) {
  const $ = _c(71);
  const {
    connectedProfile,
    proxyGrantor,
    onClose
  } = t0;
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const modalRef = useRef(null);
  let t1;
  if ($[0] !== dontShowAgain || $[1] !== onClose) {
    t1 = () => onClose(dontShowAgain);
    $[0] = dontShowAgain;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useClickAway(modalRef, t1);
  let t2;
  if ($[3] !== dontShowAgain || $[4] !== onClose) {
    t2 = () => onClose(dontShowAgain);
    $[3] = dontShowAgain;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useKeyPressEvent("Escape", t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-text-green tw-transition tw-duration-300 tw-ease-out" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      maskType: "alpha"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <mask id="mask0_8902_8329" style={t5} maskUnits="userSpaceOnUse" x="0" y="0" width="336" height="336"><rect width="336" height="336" fill="url(#paint0_radial_8902_8329)" /></mask>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <g mask="url(#mask0_8902_8329)"><circle cx="168" cy="168" r="47.5" stroke="#1F242F" /><circle cx="168" cy="168" r="47.5" stroke="#1F242F" /><circle cx="168" cy="168" r="71.5" stroke="#1F242F" /><circle cx="168" cy="168" r="95.5" stroke="#1F242F" /><circle cx="168" cy="168" r="119.5" stroke="#1F242F" /><circle cx="168" cy="168" r="143.5" stroke="#1F242F" /><circle cx="168" cy="168" r="167.5" stroke="#1F242F" /></g>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div><span className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-h-12 tw-w-12 tw-bg-green/20">{t4}<div className="tw-absolute"><svg width="336" height="336" viewBox="0 0 336 336" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t6}{t7}<defs><radialGradient id="paint0_radial_8902_8329" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(168 168) rotate(90) scale(168 168)"><stop /><stop offset="1" stopOpacity="0" /></radialGradient></defs></svg></div></span></div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="tw-text-lg tw-text-iron-50 tw-font-medium tw-mb-0">Congratulations!</p>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-max-w-xl sm:tw-flex sm:tw-space-x-4">{t8}<div className="tw-relative tw-mt-3 sm:tw-mt-0 sm:tw-max-w-sm tw-flex tw-flex-col">{t9}<p className="tw-mt-1 tw-mb-0 tw-text-base tw-text-iron-400">Click the arrow{" "}<span className="tw-font-medium tw-text-iron-50">next to your profile name in the menu</span>{" "}to switch users.</p></div></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== dontShowAgain || $[15] !== onClose) {
    t11 = () => onClose(dontShowAgain);
    $[14] = dontShowAgain;
    $[15] = onClose;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <svg className="tw-h-6 tw-w-6" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11) {
    t13 = <div className="tw-flex tw-justify-between">{t10}<div className="tw-absolute tw-right-4 tw-top-4 tw-flex tw-justify-between tw-items-center"><button type="button" aria-label="Close" title="Close" onClick={t11} className="tw-p-2.5 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-iron-950 tw-border-0 tw-text-iron-400 hover:tw-text-iron-50 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out">{t12}</button></div></div>;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== connectedProfile.pfp) {
    t14 = connectedProfile.pfp ? <img src={connectedProfile.pfp} alt="Profile Picture" className="tw-flex-shrink-0 tw-h-7 tw-w-7 tw-flex-none tw-rounded-lg tw-bg-iron-700" /> : <div className="tw-flex-shrink-0 tw-h-7 tw-w-7 tw-flex-none tw-rounded-lg tw-bg-iron-700 group-hover:tw-bg-iron-600 tw-transition tw-duration-300 tw-ease-out" />;
    $[20] = connectedProfile.pfp;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== connectedProfile.handle) {
    t15 = <div className="tw-flex tw-gap-x-2 tw-items-center"><span>{connectedProfile.handle}</span></div>;
    $[22] = connectedProfile.handle;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <div className="tw-relative tw-px-3.5 tw-h-11 tw-inline-flex tw-items-center tw-gap-x-3 tw-text-base tw-font-semibold tw-ring-1 tw-ring-white/10 tw-border-0 tw-rounded-s-lg tw-bg-iron-800 tw-text-white">{t14}{t15}</div>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="tw-relative tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-800 tw-px-2.5 tw-h-11  tw-ring-2 tw-ring-offset-4 tw-ring-offset-iron-700 tw-ring-primary-400 tw-border-0 tw-text-iron-50 tw-shadow-sm"><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16) {
    t18 = <div className="tw-relative tw-inline-flex tw-rounded-lg tw-shadow-sm">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== connectedProfile.pfp) {
    t19 = connectedProfile?.pfp ? <img src={connectedProfile.pfp} alt="Profile Picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800" /> : <div className="tw-bg-iron-600 tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-transition tw-duration-300 tw-ease-out" />;
    $[30] = connectedProfile.pfp;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== connectedProfile.handle) {
    t20 = <div className="tw-truncate tw-inline-flex tw-items-center tw-justify-between"><div className="tw-truncate tw-text-md tw-font-medium tw-text-white">{connectedProfile.handle}</div></div>;
    $[32] = connectedProfile.handle;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20) {
    t22 = <div className="tw-flex tw-justify-between tw-items-center tw-w-full">{t20}{t21}</div>;
    $[35] = t20;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t19 || $[38] !== t22) {
    t23 = <div className="tw-h-full"><div className="tw-bg-iron-700 tw-group tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-white tw-rounded-lg tw-relative tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out">{t19}{t22}</div></div>;
    $[37] = t19;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== proxyGrantor.pfp) {
    t24 = proxyGrantor.pfp ? <img src={proxyGrantor.pfp} alt="Profile Picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800" /> : <div className="tw-bg-iron-600 tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-transition tw-duration-300 tw-ease-out" />;
    $[40] = proxyGrantor.pfp;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== proxyGrantor.handle) {
    t25 = <div className="tw-truncate tw-text-md tw-font-medium tw-text-white">{proxyGrantor.handle}</div>;
    $[42] = proxyGrantor.handle;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <span className="tw-pl-2 tw-pr-0.5 tw-italic tw-text-sm tw-text-iron-400 tw-font-normal">Proxy</span>;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t25) {
    t27 = <div className="tw-flex tw-justify-between tw-items-center tw-w-full"><div className="tw-truncate tw-inline-flex tw-items-center tw-justify-between">{t25}{t26}</div></div>;
    $[45] = t25;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t24 || $[48] !== t27) {
    t28 = <div className="tw-h-full"><div className=" tw-group tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-white tw-rounded-lg tw-relative tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out">{t24}{t27}</div></div>;
    $[47] = t24;
    $[48] = t27;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t23 || $[51] !== t28) {
    t29 = <div className="tw-flex tw-flex-col tw-px-2 tw-gap-y-2 tw-mx-0">{t23}{t28}</div>;
    $[50] = t23;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="tw-h-full tw-px-2 tw-pt-2"><div className="tw-bg-transparent tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-md tw-font-medium tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-iron-300 tw-rounded-lg tw-relative tw-px-3 focus:tw-outline-none"><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 17L21 12M21 12L16 7M21 12H9M12 17C12 17.93 12 18.395 11.8978 18.7765C11.6204 19.8117 10.8117 20.6204 9.77646 20.8978C9.39496 21 8.92997 21 8 21H7.5C6.10218 21 5.40326 21 4.85195 20.7716C4.11687 20.4672 3.53284 19.8831 3.22836 19.1481C3 18.5967 3 17.8978 3 16.5V7.5C3 6.10217 3 5.40326 3.22836 4.85195C3.53284 4.11687 4.11687 3.53284 4.85195 3.22836C5.40326 3 6.10218 3 7.5 3H8C8.92997 3 9.39496 3 9.77646 3.10222C10.8117 3.37962 11.6204 4.18827 11.8978 5.22354C12 5.60504 12 6.07003 12 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Disconnect</span></div></div>;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t29) {
    t31 = <div className="tw-mt-1.5 tw-w-72 tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5"><div className="tw-mt-1 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-2 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><div role="list" className="tw-flex tw-flex-col tw-gap-y-2 tw-divide-y tw-divide-solid tw-divide-iron-700 tw-divide-x-0">{t29}{t30}</div></div></div></div>;
    $[54] = t29;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== t18 || $[57] !== t31) {
    t32 = <div className="tw-relative tw-mt-6"><div className="tw-bg-iron-700 tw-rounded-lg tw-p-8 tw-flex tw-justify-center"><div>{t18}{t31}</div></div></div>;
    $[56] = t18;
    $[57] = t31;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== dontShowAgain) {
    t33 = () => setDontShowAgain(!dontShowAgain);
    $[59] = dontShowAgain;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== dontShowAgain || $[62] !== t33) {
    t34 = <div className="tw-flex tw-h-6 tw-items-center"><input type="checkbox" id="dontShowAgain" checked={dontShowAgain} onChange={t33} className="tw-cursor-pointer tw-form-checkbox tw-h-4 tw-w-4 tw-bg-iron-800 tw-rounded tw-border-solid tw-border-gray-600 tw-text-primary-500 focus:tw-ring-primary-500" /></div>;
    $[61] = dontShowAgain;
    $[62] = t33;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="tw-ml-3 tw-text-sm tw-leading-6"><label htmlFor="dontShowAgain" className="tw-cursor-pointer tw-font-medium tw-text-iron-300">Don't show again</label></div>;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t34) {
    t36 = <div className="tw-mt-6"><div className="tw-relative tw-flex tw-items-start">{t34}{t35}</div></div>;
    $[65] = t34;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t13 || $[68] !== t32 || $[69] !== t36) {
    t37 = <div className="tw-cursor-default tw-relative tw-z-10">{t3}<div className="tw-fixed tw-inset-0 tw-z-10 tw-overflow-y-auto"><div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0"><div ref={modalRef} className="tw-overflow-hidden sm:tw-max-w-xl tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6">{t13}{t32}{t36}</div></div></div></div>;
    $[67] = t13;
    $[68] = t32;
    $[69] = t36;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  return t37;
}